import { createSlice } from "@reduxjs/toolkit";
import { resetproject } from "../resetParameters";

const initialState = {
  projectId: "",
  projectName: "",
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setProjectId(state, action) {
      state.projectId = action.payload;
    },
    setProjectName(state, action) {
      state.projectName = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetproject, (state, action) => {
      return initialState;
    });
  },
});

export const { setProjectId, setProjectName } = projectSlice.actions;
export default projectSlice.reducer;

export const selectProjectId = (state) => state.project.projectId;
export const selectProjectName = (state) => state.project.projectName;
